import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
export const FETCH_SUPPORTED_TRANSLATION_LANGUAGES = registerQuery({
  fieldName: 'languages',
  fetcher() {
    return http.get('/cosemail/v1/translation/supported-languages');
  }
});